import React, { useState } from "react";
import { Paper, Typography, Grid, Box } from "@material-ui/core";

import { IconButton } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import GameConfig from "./GameConfig";
import { Button } from "react-materialize";

const ScoreBoard = ({ currentPeriod, gameStats, teamAInfo, teamBInfo, gameData, onSaveConfig, gameId }) => {
    const [openConfig, setOpenConfig] = useState(false);

    return (
        <Paper style={{ padding: 10, marginTop: 10, backgroundColor: "#e0e0e0" }}>
            {/* <Typography variant="h6" align="center" gutterBottom>
                Marcador del Partido
            </Typography> */}

            <Grid container spacing={4} alignItems="center" justify="center">
                <Grid item xs={4} sm={4}>
                    <Typography variant="subtitle1" align="center">
                        {teamAInfo.name || "Equipo A"}
                    </Typography>
                    <Typography variant="h2" align="center">
                        {gameStats?.A?.totalPuntos || 0}
                    </Typography>
                    <Typography align="center">
                        {gameStats?.A?.porCuarto[1] || 0} - {gameStats?.A?.porCuarto[2] || 0} - {gameStats?.A?.porCuarto[3] || 0} - {gameStats?.A?.porCuarto[4] || 0}
                    </Typography>

                    <Typography align="center">
                        Faltas totales: {gameStats?.A?.faltas || 0}
                    </Typography>
                    {gameStats?.A?.faltasPorcuarto[currentPeriod] >= 5 ? (
                        <Paper style={{ backgroundColor: "red", color: "#ffffff", padding: 5 }}>
                            <Typography align="center" >
                                Faltas cuarto: {gameStats?.A?.faltasPorcuarto[currentPeriod] || 0}
                            </Typography>
                        </Paper>
                    ) : (
                        <Typography align="center" >
                            Faltas cuarto: {gameStats?.A?.faltasPorcuarto[currentPeriod] || 0}
                        </Typography>

                    )}
                </Grid>
                <Grid item xs={4} sm={4} alignContent="center" alignItems="center">
                    <GameConfig
                        open={openConfig}
                        onClose={() => setOpenConfig(false)}
                        teamAName={gameData.estado.teamAInfo?.name || "Equipo A"}
                        teamBName={gameData.estado.teamBInfo?.name || "Equipo B"}
                        initialConfig={gameData || {}}
                        gameId={gameId}
                        onSave={(config) => {
                            onSaveConfig(config); // aquí guardas en Firebase
                            setOpenConfig(false);
                        }}
                    />


                    <Typography variant="subtitle1" align="center">
                        Cuarto
                    </Typography>
                    <Typography variant="h4" align="center">
                        {currentPeriod}
                    </Typography>

                    <Box display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <IconButton color="primary"
                            style={{ backgroundColor: "#000000", padding: 15, color: "#ffffff" }}
                            onClick={() => setOpenConfig(true)}>
                            <SettingsIcon />
                        </IconButton>
                    </Box>


                </Grid>

                <Grid item xs={4} sm={4}>
                    <Typography variant="subtitle1" align="center">
                        {teamBInfo.name || "Equipo B    "}
                    </Typography>
                    <Typography variant="h2" align="center">
                        {gameStats?.B?.totalPuntos || 0}
                    </Typography>
                    <Typography align="center">
                        {gameStats?.B?.porCuarto[1] || 0} - {gameStats?.B?.porCuarto[2] || 0} - {gameStats?.B?.porCuarto[3] || 0} - {gameStats?.B?.porCuarto[4] || 0}
                    </Typography>

                    <Typography align="center">
                        Faltas totales: {gameStats?.B?.faltas || 0}
                    </Typography>
                    {gameStats?.B?.faltasPorcuarto[currentPeriod] >= 5 ? (
                        <Paper style={{ backgroundColor: "red", color: "#ffffff", padding: 5 }}>
                            <Typography align="center" style={{ backgroundColor: "red", color: "#ffffff", padding: 5 }}>
                                Faltas cuarto: {gameStats?.B?.faltasPorcuarto[currentPeriod] || 0}
                            </Typography>
                        </Paper>
                    ) : (
                        <Typography align="center" >
                            Faltas cuarto: {gameStats?.B?.faltasPorcuarto[currentPeriod] || 0}
                        </Typography>

                    )}
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ScoreBoard;
